module.exports = __webpack_public_path__ + "static/media/liquid-logotype.1842a9d1.png";